import React, { useState, useEffect } from "react";
import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  StyleSheet,
  Modal,
  ScrollView,
  ActivityIndicator,
  FlatList,
} from "react-native";

import Fonts from "../../Resources/Fonts";
import Colors from "../../Resources/Color";
import GlobalStyles from "../../Resources/Styles";

import { Menu, MenuItem } from "react-native-material-menu";
import { useScreenDimensions, useDevice } from "../_layout";

import { observer, Observer } from "mobx-react";

import { MaterialIcons } from "@expo/vector-icons";
import { AntDesign } from "@expo/vector-icons";
import { Feather } from "@expo/vector-icons";
import Ionicons from "@expo/vector-icons/Ionicons";
import { Octicons } from "@expo/vector-icons";

import { v4 as uuidv4 } from "uuid";
import IconEmptyView from "../Components/IconEmptyView";

import { useTranslation } from "react-i18next";
import SearchBar from "../Components/SearchBar";
import { useModalKeyboardShortcuts } from "../platform/guards/modalKeyboardShortcuts";

import { formatNumber } from "../utils/numberUtils";

import Svg, { Circle } from "react-native-svg";

const EditNutritionPlanGoalsView = ({ isVisible, onClose, nutritionPlan }) => {
  const { t } = useTranslation();
  const { screenSize } = useScreenDimensions();
  const { isMobile } = useDevice();

  const [showingByPercentages, setShowingByPercentages] = useState(false);

  const cancel = () => {
    nutritionPlan.resetAuxGoals();
    onClose();
  };

  const handleSave = () => {
    if (!nutritionPlan.canSaveGoals) {
      return;
    }

    nutritionPlan.savePlanGoals();
    onClose();
  };

  useModalKeyboardShortcuts({
    isVisible,
    onConfirm: handleSave,
    onCancel: cancel,
    isConfirmEnabled: nutritionPlan.canSaveGoals,
  });

  const Buttons = observer(({ bool }) => {
    const text = bool ? "save-string" : "cancel-string";

    const [isHovered, setIsHovered] = useState(false);

    return bool ? (
      <TouchableOpacity
        onPress={handleSave}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <View
          style={{
            // marginHorizontal: 20,
            backgroundColor: Colors.bubbleColor,
            borderRadius: 14,
            borderWidth: 1,
            justifyContent: "center",
            borderColor: Colors.bubbleColor,
            width: 80,
            height: 35,
            justifyContent: "center",
            alignItems: "center",
            opacity: !nutritionPlan.canSaveGoals ? 0.5 : isHovered ? 0.8 : 1,
          }}
        >
          <Text
            style={{
              textAlignVertical: "center",
              textAlign: "center",
              color: Colors.whiteColor,
            }}
          >
            {t(text)}
          </Text>
        </View>
      </TouchableOpacity>
    ) : (
      <TouchableOpacity
        onPress={cancel}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <View
          style={{
            // marginHorizontal: 20,
            backgroundColor: isHovered ? Colors.redColor : Colors.whiteColor,
            borderRadius: 14,
            borderWidth: 1,
            justifyContent: "center",
            borderColor: "red",
            width: 80,
            height: 35,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Text
            style={{
              textAlignVertical: "center",
              textAlign: "center",
              color: isHovered ? "white" : Colors.redColor,
            }}
          >
            {t(text)}
          </Text>
        </View>
      </TouchableOpacity>
    );
  });

  const TabPickerHeader = () => {
    const TabPickerButton = observer(({ isPercentages }) => {
      const [isHovered, setIsHovered] = useState(false);

      return isPercentages ? (
        <TouchableOpacity
          onPress={() =>
            nutritionPlan.setProperty("showingByPercentages", true)
          }
          style={{ flexShrink: 1 }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <View
            style={{
              alignItems: "center",
              flexShrink: 1,
            }}
          >
            <Text
              style={{
                fontSize: 14,
                fontWeight: "500",
                color:
                  nutritionPlan.showingByPercentages || isHovered
                    ? Colors.bubbleColor
                    : Colors.blackColor,
                width: "100%",
              }}
              numberOfLines={1}
            >
              {t("byPercentages-string")}
            </Text>
            <View
              style={[
                styles.underline,
                {
                  backgroundColor: !nutritionPlan.showingByPercentages
                    ? "transparent"
                    : Colors.bubbleColor,
                },
              ]}
            />
          </View>
        </TouchableOpacity>
      ) : (
        <TouchableOpacity
          onPress={() =>
            nutritionPlan.setProperty("showingByPercentages", false)
          }
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <View
            style={{
              alignItems: "center",
              marginRight: screenSize === "medium" ? 8 : 16,
            }}
          >
            <Text
              style={{
                fontSize: 14,
                fontWeight: "500",
                color:
                  !nutritionPlan.showingByPercentages || isHovered
                    ? Colors.bubbleColor
                    : Colors.blackColor,
              }}
            >
              {t("byGrams-string")}
            </Text>
            <View
              style={[
                styles.underline,
                {
                  backgroundColor: !nutritionPlan.showingByPercentages
                    ? Colors.bubbleColor
                    : "transparent",
                },
              ]}
            />
          </View>
        </TouchableOpacity>
      );
    });
    return (
      <View
        style={{
          justifyContent: "space-evenly",
          flexDirection: "row",
          alignItems: "center",
          marginTop: 16,
        }}
      >
        <TabPickerButton isPercentages={false} />

        <TabPickerButton isPercentages={true} />
      </View>
    );
  };

  const MacroEditRow = ({ macro }) => {
    const text =
      macro === "calories"
        ? "calories-string"
        : macro === "carbs"
        ? "carbohydrates-string"
        : macro === "protein"
        ? "protein-string"
        : "fats-string";

    const property =
      macro === "calories"
        ? "auxCaloriesGoal"
        : macro === "carbs"
        ? "auxCarbsGoal"
        : macro === "protein"
        ? "auxProteinGoal"
        : "auxFatsGoal";

    const color =
      macro === "carbs"
        ? Colors.carbsColor
        : macro === "protein"
        ? Colors.proteinColor
        : Colors.fatsColor;

    const ByGramGoalTextBox = ({ macro }) => {
      const [isHovered, setIsHovered] = useState(false);

      const initialValue =
        macro === "calories"
          ? nutritionPlan.auxCaloriesGoal
          : macro === "carbs"
          ? nutritionPlan.auxCarbsGoal
          : macro === "protein"
          ? nutritionPlan.auxProteinGoal
          : nutritionPlan.auxFatsGoal;

      const [text, setText] = useState(
        initialValue === 0 ? "" : String(formatNumber(initialValue))
      );

      const handleChange = (text) => {
        const formattedText = text.replace(",", ".");

        const aux = Number(formattedText);

        if (!isNaN(aux)) {
          setText(formattedText);

          const numAux = Number(formattedText);

          nutritionPlan.setGoalProperty(property, numAux);
        }
      };

      return (
        <View
          style={{
            borderColor: isHovered ? "gray" : Colors.grayColor,
            width: 80,
            height: 32,
            borderRadius: screenSize === "small" ? 8 : 10,
            borderWidth: isHovered ? 1.2 : 1,
            marginRight: 16,
            marginLeft: 24,
          }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <TextInput
            value={text}
            onChangeText={handleChange}
            placeholder={macro === "calories" ? "2400" : "0"}
            placeholderTextColor={Colors.grayColor}
            // keyboardType="decimal-pad"
            inputMode="numeric"
            style={{
              outlineStyle: "none",
              width: 80,
              height: 32,
              borderRadius: screenSize === "small" ? 8 : 10,
              color: "black",
              fontSize: screenSize === "small" ? 10.5 : 11,
              paddingHorizontal: 8,
            }}
            maxLength={10}
          />
        </View>
      );
    };

    const ByPercentageGoalTextBox = ({ macro }) => {
      const [isHovered, setIsHovered] = useState(false);

      const initialValue =
        macro === "calories"
          ? nutritionPlan.auxCaloriesGoal
          : nutritionPlan.getMacroAuxGoalPercentage(macro);

      const [text, setText] = useState(
        initialValue === 0 ? "" : String(formatNumber(initialValue))
      );

      const handleChange = (text) => {
        const formattedText = text.replace(",", ".");

        const aux = Number(formattedText);

        if (!isNaN(aux)) {
          setText(formattedText);

          const numAux = Number(formattedText);
          if (macro === "calories") {
            nutritionPlan.setGoalProperty("auxCaloriesGoal", numAux);
          } else {
            nutritionPlan.setGoalPercentage(macro, numAux);
          }
        }
      };

      return (
        <View
          style={{
            borderColor: isHovered ? "gray" : Colors.grayColor,
            width: 80,
            height: 32,
            borderRadius: screenSize === "small" ? 8 : 10,
            borderWidth: isHovered ? 1.2 : 1,
            marginRight: 16,
            marginLeft: 24,
          }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <TextInput
            value={text}
            onChangeText={handleChange}
            placeholder={macro === "calories" ? "2400" : "0"}
            placeholderTextColor={Colors.grayColor}
            // keyboardType="decimal-pad"
            inputMode="numeric"
            style={{
              outlineStyle: "none",
              width: 80,
              height: 32,
              borderRadius: screenSize === "small" ? 8 : 10,
              color: "black",
              fontSize: screenSize === "small" ? 10.5 : 11,
              paddingHorizontal: 8,
            }}
            maxLength={10}
          />
        </View>
      );
    };
    return (
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          width: "100%",
          paddingHorizontal: 40,
          marginBottom: 16,
        }}
      >
        <View
          style={{
            width: 12,
            height: 12,
            borderRadius: 50,
            backgroundColor: color,
            marginRight: 8,
            opacity: macro !== "calories" ? 1 : 0,
          }}
        />

        <Text style={{ fontSize: 16 }}>{t(text)}</Text>

        <View
          style={{
            flex: 1,
          }}
        />

        {macro !== "calories" && (
          <Observer>
            {() => (
              <Text
                style={{
                  fontSize: 16,
                  fontWeight: "500",
                  color: Colors.grayColor,
                }}
              >
                {nutritionPlan.showingByPercentages
                  ? formatNumber(nutritionPlan.getProperty(property))
                  : formatNumber(
                      nutritionPlan.getMacroAuxGoalPercentage(macro)
                    )}{" "}
                {!nutritionPlan.showingByPercentages ? "%" : "g"}
              </Text>
            )}
          </Observer>
        )}

        <Observer>
          {() => (
            <>
              {nutritionPlan.showingByPercentages ? (
                <ByPercentageGoalTextBox macro={macro} />
              ) : (
                <ByGramGoalTextBox macro={macro} />
              )}
            </>
          )}
        </Observer>

        <Observer>
          {() => (
            <View
              style={{
                width: 40,
                // alignItems: "center",
              }}
            >
              <Text style={{ fontSize: 16 }}>
                {macro === "calories"
                  ? "kcal"
                  : nutritionPlan.showingByPercentages
                  ? "%"
                  : "g"}
              </Text>
            </View>
          )}
        </Observer>
      </View>
    );
  };

  const ThreePartGoalCircle = observer(() => {
    // pull these from your store
    const carbsGoal = nutritionPlan.auxCarbsGoal; // in grams
    const proteinGoal = nutritionPlan.auxProteinGoal; // in grams
    const fatsGoal = nutritionPlan.auxFatsGoal; // in grams

    // convert grams → calories
    const carbCals = carbsGoal * 4;
    const proteinCals = proteinGoal * 4;
    const fatCals = fatsGoal * 9;
    // const totalCals = carbCals + proteinCals + fatCals;
    const totalCals = nutritionPlan.auxCaloriesGoal;

    // avoid division by zero
    // if (totalCals === 0) return null;

    // fractions
    const carbFrac = carbCals / totalCals;
    const proteinFrac = proteinCals / totalCals;
    const fatFrac = fatCals / totalCals;

    const SIZE = 120;
    const STROKE = 8;
    const R = (SIZE - STROKE) / 2;
    const C = 2 * Math.PI * R;

    // arc lengths in px
    const carbArc = C * carbFrac;
    const proteinArc = C * proteinFrac;
    const fatArc = C * fatFrac;

    return (
      <View style={{ width: SIZE, height: SIZE, marginVertical: 32 }}>
        <Svg width={SIZE} height={SIZE}>
          {/* full grey background */}
          <Circle
            cx={SIZE / 2}
            cy={SIZE / 2}
            r={R}
            stroke={Colors.borderColor}
            strokeWidth={STROKE}
            fill="none"
          />

          {/* 3) fats slice */}
          {fatsGoal > 0 && (
            <Circle
              cx={SIZE / 2}
              cy={SIZE / 2}
              r={R}
              stroke="#F76C6C" // fats
              strokeWidth={STROKE}
              fill="none"
              strokeDasharray={`${360}`}
              strokeDashoffset={0}
              strokeLinecap="round"
              transform={`rotate(-90 ${SIZE / 2} ${SIZE / 2})`}
            />
          )}

          {/* 2) protein slice */}
          {proteinGoal > 0 && (
            <Circle
              cx={SIZE / 2}
              cy={SIZE / 2}
              r={R}
              stroke="#43A047" // protein
              strokeWidth={STROKE}
              fill="none"
              strokeDasharray={`${proteinArc} ${C}`}
              strokeDashoffset={-carbArc}
              strokeLinecap="round"
              transform={`rotate(-90 ${SIZE / 2} ${SIZE / 2})`}
            />
          )}

          {/* 1) carbs slice */}
          {carbsGoal > 0 && (
            <Circle
              cx={SIZE / 2}
              cy={SIZE / 2}
              r={R}
              stroke="#FFA726" // your new “orange” for carbs
              strokeWidth={STROKE}
              fill="none"
              strokeDasharray={`${carbArc} ${C}`}
              strokeDashoffset={0}
              strokeLinecap="round"
              transform={`rotate(-90 ${SIZE / 2} ${SIZE / 2})`}
            />
          )}
        </Svg>

        {/* center text */}
        <View
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: SIZE,
            height: SIZE,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Text style={{ fontSize: 18, fontWeight: "600" }}>
            {formatNumber(totalCals)}
          </Text>
          <Text style={{ fontSize: 12, color: Colors.grayColor }}>kcal</Text>
        </View>
      </View>
    );
  });

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={isVisible}
      onRequestClose={cancel}
    >
      <View style={GlobalStyles.centeredView}>
        <View style={GlobalStyles.touchableBackground} />
        <View
          style={[
            styles.modalView,
            {
              position: "absolute",
              maxHeight: "95%",
              //   minHeight: screenSize != "large" ? 200 : 500,
              padding: screenSize === "small" ? 8 : 12,
              width: screenSize === "small" ? "90%" : 480,
              alignItems: "center",
            },
          ]}
          onStartShouldSetResponder={() => false}
        >
          <Text style={Fonts.bold18Centered}>{t("setMacroGoals-string")}</Text>

          <TabPickerHeader />

          <ThreePartGoalCircle />

          <Observer>
            {() => (
              <>
                {nutritionPlan.showingByPercentages && (
                  <MacroEditRow macro={"calories"} />
                )}
              </>
            )}
          </Observer>

          <MacroEditRow macro={"carbs"} />

          <MacroEditRow macro={"protein"} />

          <MacroEditRow macro={"fats"} />

          <Observer>
            {() => (
              <>
                {nutritionPlan.percentagesSumError && (
                  <Text>The percentages don't sum up to 100%</Text>
                )}
              </>
            )}
          </Observer>

          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              justifyContent: "center",
              gap: 64,
              marginTop: 32,
            }}
          >
            <Buttons bool={false} />
            <Buttons bool={true} />
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalView: {
    borderRadius: 18,
    backgroundColor: Colors.whiteColor,
  },
  underline: {
    height: 2,
    width: "100%",
    alignSelf: "center",
    marginTop: 2,
  },
});

export default EditNutritionPlanGoalsView;
